export const countyList: CountyList[] = [
    {
        name: 'Burgenland',
        id: 'burgenland',
        latitude: 47.8436,
        longitude: 16.5251,
        federalState: 'Bu',
    },
    {
        name: 'Kärnten',
        id: 'kaernten',
        latitude: 46.644509,
        longitude: 14.32712,
        federalState: 'Ka',
    },
    {
        name: 'Niederösterreich',
        id: 'niederoesterreich',
        latitude: 48.2,
        longitude: 15.63333,
        federalState: 'No',
    },
    {
        name: 'Oberösterreich',
        id: 'oberoesterreich',
        latitude: 48.30639,
        longitude: 14.28611,
        federalState: 'Oo',
    },
    {
        name: 'Salzburg',
        id: 'salzburg',
        latitude: 47.79941,
        longitude: 13.04399,
        federalState: 'Sa',
    },
    {
        name: 'Steiermark',
        id: 'steiermark',
        latitude: 47.06667,
        longitude: 15.45,
        federalState: 'St',
    },
    {
        name: 'Tirol',
        id: 'tirol',
        latitude: 47.26266,
        longitude: 11.39454,
        federalState: 'Ti',
    },
    {
        name: 'Vorarlberg',
        id: 'vorarlberg',
        latitude: 47.50311,
        longitude: 9.7471,
        federalState: 'Vo',
    },
    {
        name: 'Wien',
        id: 'wien',
        latitude: 48.209206,
        longitude: 16.372778,
        federalState: 'Wi',
    },
];

export type CountyList = {
    name: string;
    id: string;
    federalState: string;
    latitude: number;
    longitude: number;
};
